<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzWidth]="680"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  nzCentered>

  <ng-template #modalTitle>
    <div style="display: flex; align-items: center; gap: 8px;">
      <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
      <span>{{ 'builderScreen.columnManager.title' | translateTA }}</span>
      <nz-tag nzColor="blue" style="margin-left: auto;">
        <strong>{{ columns.length }}</strong> coluna(s)
      </nz-tag>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <!-- Lista de colunas com drag-and-drop -->
    <div class="columns-list"
      cdkDropList
      (cdkDropListDropped)="drop($event)">

      <div class="column-card"
        *ngFor="let column of columns; let i = index"
        cdkDrag
        [cdkDragDisabled]="expandedIndex === i"
        [class.expanded]="expandedIndex === i">

        <!-- Drag preview placeholder -->
        <div class="drag-placeholder" *cdkDragPlaceholder></div>

        <!-- Card colapsado: resumo -->
        <div class="column-summary" (click)="toggleExpand(i)">
          <div class="drag-handle" cdkDragHandle>
            <nz-icon nzType="holder" nzTheme="outline"></nz-icon>
          </div>
          <span class="column-index">{{ i + 1 }}</span>
          <nz-tag [nzColor]="getTypeColor(column.type)" class="type-tag">
            <nz-icon [nzType]="getTypeIcon(column.type)"></nz-icon>
            {{ column.type }}
          </nz-tag>
          <div class="column-name">
            <strong>{{ column.header }}</strong>
            <code>{{ column.field }}</code>
          </div>
          <div class="column-badges">
            <span class="badge" [class.active]="column.sortable"
              nz-tooltip nzTooltipTitle="Sortable">S</span>
            <span class="badge" [class.active]="column.filterable"
              nz-tooltip nzTooltipTitle="Filterable">F</span>
            <span class="badge" [class.active]="column.editable"
              nz-tooltip nzTooltipTitle="Editable">E</span>
          </div>
          <div class="column-actions" (click)="$event.stopPropagation()">
            <button nz-button nzType="text" nzSize="small" nzShape="circle"
              (click)="toggleExpand(i)" nz-tooltip nzTooltipTitle="Editar">
              <nz-icon nzType="edit"></nz-icon>
            </button>
            <button nz-button nzType="text" nzSize="small" nzShape="circle" nzDanger
              (click)="remove(i)" nz-tooltip nzTooltipTitle="Remover">
              <nz-icon nzType="delete"></nz-icon>
            </button>
          </div>
        </div>

        <!-- Card expandido: formulario de edicao -->
        <div class="column-detail" *ngIf="expandedIndex === i && editingColumn">
          <div class="detail-row two-cols">
            <nz-form-item>
              <nz-form-label>
                Field
                <nz-icon nzType="question-circle" nz-tooltip
                  nzTooltipTitle="Nome interno do campo (sem espaços)"
                  style="margin-left: 4px; cursor: help;"></nz-icon>
              </nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="editingColumn.field" nzSize="small" placeholder="field_name" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>Header</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="editingColumn.header" nzSize="small" placeholder="Column Header" />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="detail-row three-cols">
            <nz-form-item>
              <nz-form-label>Type</nz-form-label>
              <nz-form-control>
                <nz-select [(ngModel)]="editingColumn.type" nzSize="small"
                  (ngModelChange)="onTypeChange(editingColumn)" style="width: 100%;">
                  <nz-option nzValue="text" nzLabel="Text"></nz-option>
                  <nz-option nzValue="number" nzLabel="Number"></nz-option>
                  <nz-option nzValue="date" nzLabel="Date"></nz-option>
                  <nz-option nzValue="boolean" nzLabel="Boolean"></nz-option>
                  <nz-option nzValue="search" nzLabel="Search"></nz-option>
                  <nz-option nzValue="dropdown" nzLabel="Dropdown"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                Data Path
                <nz-icon nzType="question-circle" nz-tooltip
                  nzTooltipTitle="Caminho no JSON (ex: name ou details.price)"
                  style="margin-left: 4px; cursor: help;"></nz-icon>
              </nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="editingColumn.dataPath" nzSize="small" placeholder="field_name" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>
                Width
                <nz-icon nzType="question-circle" nz-tooltip
                  nzTooltipTitle="Ex: 150px, 20% ou auto"
                  style="margin-left: 4px; cursor: help;"></nz-icon>
              </nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="editingColumn.width" nzSize="small" placeholder="150px" />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="detail-row toggles">
            <label nz-checkbox [(ngModel)]="editingColumn.sortable">Sortable</label>
            <label nz-checkbox [(ngModel)]="editingColumn.filterable">Filterable</label>
            <label nz-checkbox [(ngModel)]="editingColumn.editable">Editable</label>
          </div>

          <!-- Config Search (dentro do card) -->
          <div class="detail-extra" *ngIf="editingColumn.type === 'search'">
            <nz-divider nzText="Configuração Search" nzOrientation="left"></nz-divider>
            <div class="detail-row three-cols">
              <nz-form-item>
                <nz-form-label>Entidade</nz-form-label>
                <nz-form-control>
                  <input nz-input [(ngModel)]="editingSearchEntity" nzSize="small" placeholder="Ex: Mktpcompany" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>Campo Chave</nz-form-label>
                <nz-form-control>
                  <input nz-input [(ngModel)]="editingSearchKeyField" nzSize="small" placeholder="Ex: CODECOMPANY" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>Campo Valor</nz-form-label>
                <nz-form-control>
                  <input nz-input [(ngModel)]="editingSearchValueField" nzSize="small" placeholder="Ex: NAME" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <label nz-checkbox [(ngModel)]="editingSearchShowKey">Exibir chave junto ao valor</label>
          </div>

          <!-- Config Dropdown (dentro do card) -->
          <div class="detail-extra" *ngIf="editingColumn.type === 'dropdown'">
            <nz-divider nzText="Opções do Dropdown" nzOrientation="left"></nz-divider>
            <div class="dropdown-option-row" *ngFor="let opt of editingDropdownOptions; let oi = index">
              <input nz-input [(ngModel)]="opt.value" nzSize="small" placeholder="Valor" style="width: 140px;" />
              <input nz-input [(ngModel)]="opt.label" nzSize="small" placeholder="Label" style="flex: 1;" />
              <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeDropdownOption(editingDropdownOptions, oi)">
                <nz-icon nzType="delete"></nz-icon>
              </button>
            </div>
            <button nz-button nzType="dashed" nzSize="small" nzBlock
              (click)="addDropdownOption(editingDropdownOptions)">
              <nz-icon nzType="plus"></nz-icon> Adicionar Opção
            </button>
          </div>

          <div class="detail-actions">
            <button nz-button nzType="primary" nzSize="small" (click)="saveEdit()">
              <nz-icon nzType="check"></nz-icon> Salvar
            </button>
            <button nz-button nzType="default" nzSize="small" (click)="cancelEdit()">
              Cancelar
            </button>
          </div>
        </div>
      </div>

      <!-- Estado vazio -->
      <div *ngIf="columns.length === 0 && !isAddingNew" class="empty-state">
        <nz-empty nzNotFoundContent="Nenhuma coluna configurada" [nzNotFoundImage]="'simple'">
          <div nz-empty-footer>
            <button nz-button nzType="primary" (click)="startAddNew()">
              <nz-icon nzType="plus"></nz-icon> Adicionar Primeira Coluna
            </button>
          </div>
        </nz-empty>
      </div>
    </div>

    <!-- Card para nova coluna -->
    <div class="column-card new-column" *ngIf="isAddingNew">
      <div class="column-summary new-header">
        <nz-icon nzType="plus-circle" nzTheme="twotone" [nzTwotoneColor]="'#1890ff'"></nz-icon>
        <strong>Nova Coluna</strong>
      </div>
      <div class="column-detail">
        <div class="detail-row two-cols">
          <nz-form-item>
            <nz-form-label>Field</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="newColumn.field" nzSize="small" placeholder="field_name" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label>Header</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="newColumn.header" nzSize="small" placeholder="Column Header" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="detail-row three-cols">
          <nz-form-item>
            <nz-form-label>Type</nz-form-label>
            <nz-form-control>
              <nz-select [(ngModel)]="newColumn.type" nzSize="small"
                (ngModelChange)="onTypeChange(newColumn)" style="width: 100%;">
                <nz-option nzValue="text" nzLabel="Text"></nz-option>
                <nz-option nzValue="number" nzLabel="Number"></nz-option>
                <nz-option nzValue="date" nzLabel="Date"></nz-option>
                <nz-option nzValue="boolean" nzLabel="Boolean"></nz-option>
                <nz-option nzValue="search" nzLabel="Search"></nz-option>
                <nz-option nzValue="dropdown" nzLabel="Dropdown"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label>Data Path</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="newColumn.dataPath" nzSize="small" placeholder="field_name" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label>Width</nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="newColumn.width" nzSize="small" placeholder="150px" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="detail-row toggles">
          <label nz-checkbox [(ngModel)]="newColumn.sortable">Sortable</label>
          <label nz-checkbox [(ngModel)]="newColumn.filterable">Filterable</label>
          <label nz-checkbox [(ngModel)]="newColumn.editable">Editable</label>
        </div>

        <!-- Config Search (nova coluna) -->
        <div class="detail-extra" *ngIf="newColumn.type === 'search'">
          <nz-divider nzText="Configuração Search" nzOrientation="left"></nz-divider>
          <div class="detail-row three-cols">
            <nz-form-item>
              <nz-form-label>Entidade</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="newSearchEntity" nzSize="small" placeholder="Ex: Mktpcompany" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>Campo Chave</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="newSearchKeyField" nzSize="small" placeholder="Ex: CODECOMPANY" />
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label>Campo Valor</nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="newSearchValueField" nzSize="small" placeholder="Ex: NAME" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <label nz-checkbox [(ngModel)]="newSearchShowKey">Exibir chave junto ao valor</label>
        </div>

        <!-- Config Dropdown (nova coluna) -->
        <div class="detail-extra" *ngIf="newColumn.type === 'dropdown'">
          <nz-divider nzText="Opções do Dropdown" nzOrientation="left"></nz-divider>
          <div class="dropdown-option-row" *ngFor="let opt of newDropdownOptions; let oi = index">
            <input nz-input [(ngModel)]="opt.value" nzSize="small" placeholder="Valor" style="width: 140px;" />
            <input nz-input [(ngModel)]="opt.label" nzSize="small" placeholder="Label" style="flex: 1;" />
            <button nz-button nzType="text" nzDanger nzSize="small" (click)="removeDropdownOption(newDropdownOptions, oi)">
              <nz-icon nzType="delete"></nz-icon>
            </button>
          </div>
          <button nz-button nzType="dashed" nzSize="small" nzBlock
            (click)="addDropdownOption(newDropdownOptions)">
            <nz-icon nzType="plus"></nz-icon> Adicionar Opção
          </button>
        </div>

        <div class="detail-actions">
          <button nz-button nzType="primary" nzSize="small" (click)="saveNew()">
            <nz-icon nzType="check"></nz-icon> Salvar
          </button>
          <button nz-button nzType="default" nzSize="small" (click)="cancelNew()">
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- Botao adicionar -->
    <div *ngIf="!isAddingNew && columns.length > 0" style="margin-top: 12px;">
      <button nz-button nzType="dashed" nzBlock (click)="startAddNew()">
        <nz-icon nzType="plus"></nz-icon> Adicionar Nova Coluna
      </button>
    </div>
  </ng-container>

  <!-- Footer -->
  <ng-template #modalFooter>
    <span style="float: left; line-height: 32px; color: #8c8c8c; font-size: 12px;">
      {{ columns.length }} coluna(s) configurada(s)
    </span>
    <button nz-button nzType="default" (click)="close()">Cancelar</button>
    <button nz-button nzType="primary" (click)="save()">
      <nz-icon nzType="check"></nz-icon> Aplicar Colunas
    </button>
  </ng-template>
</nz-modal>
